module.exports = __webpack_public_path__ + "static/media/checked_red.9127b02e.svg";